import axios from 'axios';
import {
	CheckDeceasedNationalIdResponse,
	CreateHeirTransferPayload,
	CreateShareholderPayload,
	CreateShareholderResponse,
	HeirRequestListResponse,
	HeirTransfer,
} from '../models/heir';
import { JsonResponse } from 'core/models/response';

export const createEmptyHeirObject = () => {
	return {
		shareholder_id: '',
		free_common_shares_count: 0,
		suspended_common_shares_count: 0,
		mortgaged_common_shares_count: 0,
		free_preferred_shares_count: 0,
		suspended_preferred_shares_count: 0,
		mortgaged_preferred_shares_count: 0,
	};
};

export const onGetHeirsTransferList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<HeirRequestListResponse>>('dashboard/actions/heirloom', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetHeirsTransferById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<HeirTransfer>>(`dashboard/actions/heirloom/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckCompanyShareholder = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<CheckDeceasedNationalIdResponse>>(
			`dashboard/actions/heirloom/check-company-shareholder`,
			{
				params: { national_id },
			},
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGenerateCompanyShareholder = async (data: CreateShareholderPayload) => {
	try {
		const response = await axios.post<JsonResponse<CreateShareholderResponse>>(`dashboard/actions/heirloom/create-shareholder`, data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateHeirTransfer = async (data: FormData) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/heirloom`, data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelPendingTransactions = async (company_shareholder_id: number) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/heirloom/cancel-pending-transactions`, {
			company_shareholder_id,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
